import { PaginationState } from "../../../models/PaginationState";
import { Button, Select, Spinner, Text } from "@fluentui/react-components";

// styles
import './PaginationControl.Styles.css';
import { ChevronLeft16Regular, ChevronRight16Regular } from "@fluentui/react-icons";

type IProps = {
    paginationState: PaginationState
    showedRecords: number;
    isLoading: boolean;
    setPageNumber: (pageNumber: number) => void;
    setPageSize: (pageSize: number) => void;
}


export const PaginationControlComponent = (props: IProps) => {

    const onSelectPageSize = (e: React.ChangeEvent<HTMLSelectElement>) => {
        props.setPageNumber(1);
        props.setPageSize(Number(e.target.value));
    };

    const currentPage = props.paginationState?.pageNumber ?? 1;
    const totalPages = props.paginationState?.totalPages ?? 0;
    const totalRecords = props.paginationState?.totalRecords ?? 0;
    const pageSize = props.paginationState?.pageSize ?? 10;
    const recordFrom = totalRecords === 0 ? 0 : (currentPage - 1) * pageSize + 1;
    const recordTo = Math.min(currentPage * pageSize, totalRecords);

    return (
        <div className="PaginationContainer">
            <div className="PaginationLoading">
                {props.isLoading && <Spinner size="extra-tiny" />}
            </div>

            <div className="PaginationRecords">
                <Text size={200} weight="regular" style={{ color: 'var(--ichtys-text-secondary)' }}>
                    {recordFrom} a {recordTo} de {totalRecords} registros
                </Text>
            </div>

            <div className="PaginationPageSize">
                <Text size={200} style={{ color: 'var(--ichtys-text-secondary)', marginRight: '0.4em' }}>Filas:</Text>
                <Select
                    className="PaginationSelect"
                    onChange={onSelectPageSize}
                    value={props.paginationState?.pageSize?.toString() ?? "10"}
                >
                    {["10", "20", "50", "100", "500", "1000"].map((option: string) =>
                        <option key={option} value={option}>{option}</option>
                    )}
                </Select>
            </div>

            <div className="PaginationNav">
                <Button
                    appearance="outline"
                    icon={<ChevronLeft16Regular />}
                    size="small"
                    onClick={() => props.setPageNumber(currentPage - 1)}
                    disabled={currentPage <= 1 || props.isLoading}
                >
                    Anterior
                </Button>

                <span className="PaginationPageInfo">
                    <Text size={200} style={{ color: 'var(--ichtys-text-secondary)' }}>Página</Text>
                    <Text size={300} weight="semibold" style={{ margin: '0 0.3em' }}>{currentPage}</Text>
                    <Text size={200} style={{ color: 'var(--ichtys-text-secondary)' }}>de {totalPages}</Text>
                </span>

                <Button
                    appearance="outline"
                    icon={<ChevronRight16Regular />}
                    iconPosition="after"
                    size="small"
                    onClick={() => props.setPageNumber(currentPage + 1)}
                    disabled={currentPage >= totalPages || props.isLoading}
                >
                    Siguiente
                </Button>
            </div>
        </div>
    );
}